angular.module('directives').directive('passwordChanger',
	function () {
		return {
			restrict: 'E',
			template: require('./passwordChanger.html'),
			scope: {
				onAfterSave: '=pwcOnAfterSave',
				data: '=pwcData',
				requireOldPassword: '=?pwcRequireOldPassword',
				oldPasswordError: '=?pwcOldPasswordError'
			}
		}
	}
);